export default __webpack_public_path__ + "static/media/plusIcon.ed030bdc.svg";